import React from "react";
import {Link} from "react-router-dom";

export default function TermsPage(){
    return(
        <div className="custor-welcome" style={{maxWidth:"900px",margin:"0 auto"}}>
            <h1>Terms of Service</h1>
            <p>Last updated: September 2026</p>

            <h2>1. Service</h2>
            <p>Custor is a software analysis service that helps users understand software projects, their architecture, dependencies, and potential code quality or structural issues.</p>

            <h2>2. Accounts</h2>
            <p>You are responsible for maintaining the security of your account and for all activity performed through your account.</p>

            <h2>3. Use of the Service</h2>
            <p>You may use Custor only for lawful purposes and in accordance with these Terms. You must have the necessary rights and permissions to upload or analyze any software project or other content submitted to Custor.</p>

            <h2>4. Subscriptions and Payments</h2>
            <p>Some Custor features require a paid subscription. Prices and available plans are displayed before purchase. Payments are processed by our payment service provider, Creem.</p>
            <h2>5. User Content</h2>
            <p>You retain ownership of the software and other content you submit to Custor. You grant Custor the limited rights necessary to process that content and provide the requested analysis service.</p>

            <h2>6. Service Availability</h2>
            <p>We aim to keep Custor available and reliable, but we do not guarantee uninterrupted or error-free operation of the service.</p>

            <h2>7. Changes to the Service</h2>
            <p>We may modify or improve Custor from time to time. We may also update these Terms when necessary. Updated Terms will be published on this page.</p>

            <h2>8. Termination</h2>
            <p>We may suspend or terminate access to accounts that materially violate these Terms or misuse the service.</p>

            <h2>9. Contact</h2>
            <p>If you have questions about these Terms, please contact us through the contact information provided on the Custor website.</p>

            <div style={{marginTop:"30px"}}>
                <Link to="/privacy">Privacy Policy</Link>{" · "}
                <Link to="/refund">Refund Policy</Link>{" · "}
                <Link to="/login">Back to Custor</Link>
            </div>
        </div>
    );
}